const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/user/app/$appId/features-mail/config.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { MailConfigFilterParamSchema } from '@apps/main/features/user/pages/app/detail/feature-mail/config-schema';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_main/user/app/$appId/features-mail/config')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: MailConfigFilterParamSchema
});